import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';

import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { RimViews } from '../../../../store/details/rim/model';
import { TabDetails } from '../../../../store/details/rim/types';
import { changeView } from '../../../../store/details/rim/actions';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './rim-side-nav.module.css';
import withParams from '../../../common/withParams';

interface PropsFromState {
  readonly currentView: RimViews;
  readonly id: number;
  readonly itemsTabs: { [key: string]: TabDetails };
}

interface PropsFromDispatch {
  readonly changeView: typeof changeView;
}

type AllProps = PropsFromDispatch & PropsFromState & ConnectedReduxProps& {
  params: {
    instructionId: number;
  };
};

interface ViewItem {
  view: RimViews;
  isSelected: boolean;
  item: React.JSX.Element;
}

class RimSideNav extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  private isTabForViewSaved = (item: RimViews) => {
    if (!this.props.itemsTabs[`${this.props.id}`]) { return false; }
    return this.props.itemsTabs[`${this.props.id}`][item].isSaved;
  }

  private get views(): ViewItem[] {
    return Object.values(RimViews).filter(value => !isNaN(Number(value)))
      .map<ViewItem>(value => {
        const castedValue = value as RimViews;
        const isSelected = this.props.currentView === castedValue;

        return {
          isSelected: isSelected,
          view: castedValue,
          item: (
            <div
              onClick={() => {
                this.props.changeView({ view: value as RimViews, instructionId: this.props.params.instructionId });
              }}
              className={isSelected ? styles.viewItemTextSelected : styles.viewItem}
              key={value}>
              <div className={isSelected ? styles.viewItemSelected : this.isTabForViewSaved(castedValue) ? styles.viewItemSaved : ''}></div>
              {this.localization.get(`details.rim.${RimViews[castedValue].toString()}.header`)}
            </div>
          )
        };
      });
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.scrollableContent}>
          {this.views.map(x => x.item)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsRim }, caseState: { selectedCase: { caseCode } } }: ApplicationState): PropsFromState => ({
  currentView: detailsRim.currentView,
  itemsTabs: detailsRim.rimTotalItemsTabs,
  id: detailsRim.rimHeaderId
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  changeView: (data: { view: RimViews, instructionId: number}) => dispatch(changeView(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(withParams(RimSideNav));
